<div class="width-100 height-100 recomendado-aplicado">
  <div class="timeline filters">
    <div class="btn-group" uib-dropdown dropdown-append-to-body="true" uib-dropdown-toggle>
      <label type="button" class="btn btn-white btn-sm">
         {{filters.propriedade.descricao || 'Propriedade' | capitalize}}
      </label>
      <label type="button" class="btn btn-white btn-sm">
         <span class="caret"></span>
      </label>
      <ul class="dropdown-menu" uib-dropdown-menu role="menu">
        <li role="menuitem" ng-repeat="propriedade in propriedades track by propriedade.id">
          <a ng-click="setPropriedade(propriedade, $event)" href="#">{{::propriedade.descricao | capitalize}}</a>
        </li>
      </ul>
    </div>

    <div class="btn-group" ng-show="loadingSelectFilters">
      <span>
        <i class="pull-right fa fa-spinner fa-spin"></i>
      </span>
    </div>

    <div class="btn-group" uib-dropdown dropdown-append-to-body="true" uib-dropdown-toggle ng-hide="loadingSelectFilters">
      <label type="button" class="btn btn-white btn-sm">
        {{(filters.gleba.descricao || 'Talhão') | capitalize}}
      </label>
      <label type="button" class="btn btn-white btn-sm">
         <span class="caret"></span>
      </label>
      <ul class="dropdown-menu" uib-dropdown-menu role="menu">
        <li role="menuitem" ng-show="filters.gleba">
          <a ng-click="setFilterAttribute('gleba', null, $event)" href="#">Todas</a>
        </li>
        <li role="menuitem" ng-repeat="gleba in glebas track by gleba.id">
          <a ng-click="setFilterAttribute('gleba',gleba, $event)" href="#">{{::gleba.descricao | capitalize}}</a>
        </li>
      </ul>
    </div>

    <div class="btn-group" uib-dropdown dropdown-append-to-body="true" uib-dropdown-toggle>
      <label type="button" class="btn btn-white btn-sm">
         {{filters.grupoInsumo.descricao || 'Grupo de Insumos' | capitalize}}
      </label>
      <label type="button" class="btn btn-white btn-sm">
         <span class="caret"></span>
      </label>
      <ul class="dropdown-menu" uib-dropdown-menu role="menu">
        <li role="menuitem" ng-show="filters.grupoInsumo">
          <a ng-click="setFilterAttribute('grupoInsumo', null, $event)" href="#">Todas</a>
        </li>
        <li role="menuitem" ng-repeat="grupo in gruposInsumos track by grupo.id">
          <a ng-click="setFilterAttribute('grupoInsumo', grupo, $event)" href="#">{{::grupo.descricao | capitalize}}</a>
        </li>
      </ul>
    </div>

    <div class="btn-group" uib-dropdown dropdown-append-to-body="true" uib-dropdown-toggle>
      <label type="button" class="btn btn-white btn-sm">
         {{filters.atividade.descricao || 'Atividade' | capitalize}}
      </label>
      <label type="button" class="btn btn-white btn-sm">
         <span class="caret"></span>
      </label>
      <ul class="dropdown-menu" uib-dropdown-menu role="menu">
        <li role="menuitem" ng-show="filters.atividade">
          <a ng-click="setFilterAttribute('atividade', null, $event)" href="#">Todas</a>
        </li>
        <li role="menuitem" ng-repeat="atividade in atividades track by atividade.id">
          <a ng-click="setFilterAttribute('atividade', atividade, $event)" href="#">{{::atividade.descricao | capitalize}}</a>
        </li>
      </ul>
    </div>

    <div class="btn-group" uib-dropdown dropdown-append-to-body="true" uib-dropdown-toggle ng-hide="loadingSelectFilters">
      <label type="button" class="btn btn-white btn-sm">
        {{(filters.operacao.descricao || 'Operaçao') | capitalize}}
      </label>
      <label type="button" class="btn btn-white btn-sm">
         <span class="caret"></span>
      </label>
      <ul class="dropdown-menu" uib-dropdown-menu role="menu">
        <li role="menuitem" ng-repeat="operacao in operacoes track by operacao.id">
          <a ng-click="setFilterAttribute('operacao',operacao, $event)" href="#">{{::operacao.descricao | capitalize}}</a>
        </li>
      </ul>
    </div>

    <div class="btn-group" uib-dropdown dropdown-append-to-body="true" uib-dropdown-toggle>
      <label type="button" class="btn btn-white btn-sm">
         {{period.periodo || 'Período'}}
      </label>
      <label type="button" class="btn btn-white btn-sm">
         <span class="caret"></span>
      </label>
      <ul class="dropdown-menu" uib-dropdown-menu role="menu">
        <li role="menuitem" ng-repeat="periodo in filtroPeriodo">
          <a ng-click="setPeriodo(periodo, $event)" href="#">{{::periodo.descricao | capitalize}}</a>
        </li>
        <li role="menuitem">
          <a ng-click="openPeriodsFilter($event)" href="#">Customizado</a>
        </li>
      </ul>
    </div>

    <div class="btn-group">
      <label class="btn btn-success btn-sm" ng-click="getDados()">
        Pesquisar
      </label>
    </div>
    <div class="btn-group">
      <label class="btn btn-danger btn-sm" ng-click="init()">
        Limpar
      </label>
    </div>

    <div class="btn-group pull-right">
      <span class="btn btn-primary btn-sm" ng-click="changeView()" title="Alternar modo de visualização">
        <i class="fa fa-th"></i>
      </span>
    </div>
  </div>

  <div ng-show="view === 'chart'" class="width-90" id="area_grafico">
    <canvas id="grafico"></canvas>
  </div>

  <div ng-if="view === 'table'" class="padding-10">
    <a ng-print print-element-id="table-products" class="pull-right">
      <i class="fa fa-print"></i>
      Imprimir
    </a>

    <table class="table table-striped table-hover" id="table-products">
      <thead>
      <tr>
        <th>Produto</th>
        <th>Unidade</th>
        <th>Total Recomendado</th>
        <th>Total Aplicado</th>
        <th>Diferença</th>
        <th>%</th>
      </tr>
      </thead>

      <tbody>
      <tr ng-repeat="produto in produtos">
        <td>{{produto.produto.descricao}}</td>
        <td>{{produto.unidade.abreviatura}}</td>
        <td>{{produto.total_recomendado | number}}</td>
        <td>{{produto.total_aplicado | number}}</td>
        <td>{{difference(produto) | number}}</td>
        <td>{{percent(produto) | number}}</td>
      </tr>
      </tbody>
    </table>
  </div>
</div>
